import type {
  ConfigurationParameters,
  HTTPHeaders
} from '@libs/openapi/service-identity-core'
import {
  CheckersApi,
  HealthApi,
  Configuration as ServiceIdentityCoreResourceConfiguration,
  SettingsApi,
  TenantsApi
} from '@libs/openapi/service-identity-core'
import { IdentitiesApiExtended } from '@libs/openapi-clients/extendedClients/IdentitiesApiExtended'
import type { Maybe } from '@libs/productive-codebases/toolbox/src'
import fetch from 'isomorphic-fetch'
import {
  type IOpenApiClientBasePaths,
  IOpenApiClientService,
  type IOpenApiClients,
  type IServiceIdentityCore
} from './types'

export class OpenApiClients implements IOpenApiClients {
  serviceIdentityCore!: IServiceIdentityCore

  private _basePath: Maybe<IOpenApiClientBasePaths> = null

  // Optional headers (authentication, language, etc)
  private _headers?: HTTPHeaders

  private _defaultConfiguration: ConfigurationParameters = {
    fetchApi: fetch
  }

  /**
   * OpenAPI clients base or relative base paths, depending if server or client side.
   */
  setBasePath(basePaths: IOpenApiClientBasePaths): this {
    this._basePath = basePaths
    return this
  }

  /**
   * Set the authentication token, needed server side.
   * Client queries will use `tenableServicesProxyRouter` middleware that ensures authentication.
   */
  setHeaders(headers: HTTPHeaders): this {
    this._headers = headers
    return this
  }

  /**
   * Instanciate all OpenApi clients.
   */
  createClients(): this {
    // service-identity-core
    this.serviceIdentityCore = {
      checkers: new CheckersApi(
        new ServiceIdentityCoreResourceConfiguration(
          this._createConfiguration(IOpenApiClientService.serviceIdentityCore)
        )
      ),
      health: new HealthApi(
        new ServiceIdentityCoreResourceConfiguration(
          this._createConfiguration(IOpenApiClientService.serviceIdentityCore)
        )
      ),
      identities: new IdentitiesApiExtended(
        new ServiceIdentityCoreResourceConfiguration(
          this._createConfiguration(IOpenApiClientService.serviceIdentityCore)
        )
      ),
      settings: new SettingsApi(
        new ServiceIdentityCoreResourceConfiguration(
          this._createConfiguration(IOpenApiClientService.serviceIdentityCore)
        )
      ),
      tenants: new TenantsApi(
        new ServiceIdentityCoreResourceConfiguration(
          this._createConfiguration(IOpenApiClientService.serviceIdentityCore)
        )
      )
    }

    return this
  }

  /**
   * Private
   */

  /**
   * Create configurations for clients.
   */
  private _createConfiguration(
    serviceName: IOpenApiClientService
  ): ConfigurationParameters {
    const basePath = this._basePath ? this._basePath[serviceName] : undefined

    return {
      ...this._defaultConfiguration,
      basePath,
      headers: this._headers
    }
  }
}
